import React from 'react';
import { Play } from 'lucide-react';

/**
 * Renders the YouTube player / thumbnail / Coming Soon placeholder
 * inside the hero episode card. Extracted from HeroCMS.jsx Feb 17, 2026
 * to reduce parent component complexity. Behavior identical.
 */
export const HeroEpisodePlayer = ({ episode }) => {
  if (!episode) return null;

  // Show Coming Soon overlay if marked as such in CMS
  if (episode.showComingSoon) {
    if (episode.thumbnailUrl) {
      return (
        <div className="episode-thumbnail-placeholder">
          <img
            src={episode.thumbnailUrl}
            alt={episode.title}
            className="thumbnail-image"
          />
          <div className="thumbnail-overlay">
            <div className="overlay-content">
              <Play size={72} className="play-icon" />
              <span className="coming-soon-badge">Coming Soon</span>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="coming-soon-placeholder">
        <div className="coming-soon-content">
          <Play size={64} className="coming-soon-icon" />
          <h3>Coming Soon!</h3>
          <p>This episode is currently being edited and will be available soon.</p>
        </div>
      </div>
    );
  }

  // Show YouTube video if valid ID exists and NOT marked as coming soon
  if (episode.youtubeId && episode.hasValidYouTubeId) {
    return (
      <iframe
        src={`https://www.youtube.com/embed/${episode.youtubeId}?rel=0&modestbranding=1`}
        title={episode.title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="youtube-embed"
      ></iframe>
    );
  }

  // Show thumbnail with play icon (no Coming Soon badge since showComingSoon is false)
  if (episode.thumbnailUrl) {
    return (
      <div className="episode-thumbnail-placeholder">
        <img
          src={episode.thumbnailUrl}
          alt={episode.title}
          className="thumbnail-image"
        />
        <div className="thumbnail-overlay">
          <div className="overlay-content">
            <Play size={72} className="play-icon" />
          </div>
        </div>
      </div>
    );
  }

  // Fallback placeholder
  return (
    <div className="episode-thumbnail-placeholder" style={{ background: '#1e293b' }}>
      <div className="overlay-content">
        <Play size={72} className="play-icon" />
      </div>
    </div>
  );
};
